<template>
    <div :class="['send_pop_right_mask', 'animated', showAnimated ? 'findinMask' : 'findOutMask']" v-if="isOk">
      <div :class="['send_pop_right', 'animated', showAnimated ? 'fadeInRightBig' : 'fadeOutRightBig']">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>广告图片资源</span>
            </div>
            <div>
                <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                stripe
                border
                fit
                style="width: 100%">
                <el-table-column
                    prop="id"
                    header-align="center"
                    width="145"
                    label="设备编号">
                </el-table-column>
                <el-table-column
                    prop="name"
                    header-align="center"
                    min-width="180"
                    label="设备昵称">
                </el-table-column>
                <el-table-column
                    prop="uuid"
                    header-align="center"
                    min-width="165"
                    label="UUID	">
                </el-table-column>
                <el-table-column
                    prop="opt"
                    header-align="center"
                    width="145"
                    label="操作">
                    <template scope="scope">
                    <el-button type="text" size="small" @click="oneSend(scope.row.uuid)">单机升级</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
            <div class="table_pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNo"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal">
                </el-pagination>
            </div>
        </el-card>
        <span @click="boxColose" 
            style="position: absolute; top: 0;left:0;padding:10px;color:#FF4949">
            <i class="el-icon-close Danger"></i></span>
      </div>
    </div>
</template>
<script>
    import $axios from '../../https/config'

    export default {
      props: ['sendShow', 'versionPath'],
      data () {
        return {
          showAnimated: true,
          table_loading: true,
          deviceData: [],
          pageNo: 1,
          pageSize: 10,
          pageTotal: 0,
          isAssigned: 1
        }
      },
      computed: {
        isOk: function () {
          this.showAnimated = true
          return this.sendShow
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryDeviceList()
      },
      methods: {
        boxColose () {
          this.showAnimated = false
          var _this = this
          setTimeout(function () {
            _this.$emit('closeSendRight', false)
          }, 500)
        },
        queryDeviceList (tPageNo, tPageSize, tttt) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            isAssigned: _this.isAssigned
          }
          this.table_loading = true
          $axios.get('/device/getDeviceList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    name: itemData.alias,
                    id: itemData.deviceCode,
                    uuid: itemData.uuid
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryDeviceList(this.pageNo, this.pageSize)
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryDeviceList(this.pageNo, this.pageSize)
        },
        oneSend (uuid) {
          var that = this
          var params = {
            zippath: this.versionPath
          }
          $axios.post('/manager/pushVersion?uuid=' + uuid, params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              that.$message({
                type: 'success',
                message: '推送成功'
              })
            } else {
              that.$message({
                type: 'error',
                message: '推送失败'
              })
            }
          }, function () {
            that.$message({
              type: 'error',
              message: '推送失败'
            })
          })
        }
      }
    }
</script>
<style lang="scss">
  .send_pop_right_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 1000;
  }
  .send_pop_right {
    top: 0;
    right: 0;
    left: 20%;
    bottom: 0;
    z-index: 1001;
    position: fixed;
    background: #eef1f6;

    .see_title {
        background: white; 
        padding: 10px;
        border-bottom: 1px solid #ccc;

        p {
            margin:0;
            padding: 5px;
            color: black;
            font-size: 20px;
            font-weight: 500;
        }
        span {
            margin-right: 5px;
        }
    }
  }

  .animated {
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }

    .animated.infinite {
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }

    .animated.hinge {
      -webkit-animation-duration: 2s;
      animation-duration: 2s;
    }

    @-webkit-keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }

    @keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }
    }

    .fadeInRightBig {
      -webkit-animation-name: fadeInRightBig;
      animation-name: fadeInRightBig;
    }

    @-webkit-keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    @keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }
    .findinMask {
      -webkit-animation-name: findinMask;
      animation-name: findinMask;
    }



    @-webkit-keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    @keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    .fadeOutRightBig {
      -webkit-animation-name: fadeOutRightBig;
      animation-name: fadeOutRightBig;
    }

    @-webkit-keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }

    @keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }
    .findOutMask {
      -webkit-animation-duration: 0.5s;
      animation-duration: 0.5s;
      -webkit-animation-name: findOutMask;
      animation-name: findOutMask;
    }
</style> 


// WEBPACK FOOTER //
// src/page/versionMgr/soloSendRightPop.vue